import { render, staticRenderFns } from "./proofCategoryAction.vue?vue&type=template&id=40fec87a"
import script from "./proofCategoryAction.vue?vue&type=script&lang=js"
export * from "./proofCategoryAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports